var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgApple(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14118_55801)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_14118_55801)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.0523 6.62015C10.2766 6.62015 9.07596 5.73823 7.81154 5.77011C6.14334 5.79136 4.61327 6.73703 3.75261 8.23521C2.02066 11.2422 3.30634 15.6837 4.99579 18.1275C5.82457 19.3176 6.80212 20.6564 8.09842 20.6139C9.3416 20.5607 9.80912 19.8063 11.3179 19.8063C12.8161 19.8063 13.2411 20.6139 14.5587 20.582C15.8975 20.5607 16.7475 19.3707 17.5657 18.17C18.5114 16.7887 18.9045 15.4499 18.9258 15.3755C18.8939 15.3649 16.3225 14.3767 16.2907 11.4016C16.2694 8.91524 18.3201 7.72519 18.4157 7.67207C17.2469 5.96137 15.4512 5.77011 14.8243 5.72761C13.188 5.6001 11.8173 6.62015 11.0523 6.62015V6.62015ZM13.8149 4.11254C14.5056 3.28375 14.9625 2.12558 14.835 0.978027C13.8468 1.02053 12.6567 1.63681 11.9448 2.46559C11.3073 3.19875 10.7548 4.37817 10.9035 5.50447C11.998 5.58948 13.1243 4.94132 13.8149 4.11254V4.11254Z",
    fill: "black"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14118_55801"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.2509,
    height: 21.2509,
    fill: "white",
    transform: "translate(0.759766 0.225098)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_14118_55801"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.2509,
    height: 21.2509,
    fill: "white",
    transform: "translate(0.759766 0.225098)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.5ffc7ce9e725d5888db96e55ccd96587.svg";
export { ForwardRef as ReactComponent };